<template>
  <div class="page">
    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="planName" label="疫苗名称"> </el-table-column>
      <el-table-column prop="operUserName" label="添加人"> </el-table-column>
      <el-table-column prop="operTime" label="时间">
        <template slot-scope="scope">
          {{ $public.FTime(scope.row.planDate, "YYYY-MM-DD") }}
        </template>
      </el-table-column>
      <el-table-column prop="operTime" label="状态">
        <template slot-scope="scope">
          {{ scope.row.isFinish ? "已完成" : "未完成" }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="操作" width="80" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handelNavClick(scope.row)"
            >查看</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>
    <div
      style="margin: 20px; text-align: right"
      v-if="this.$buttonAuthority('huoti-zongcang-delrecord') && tableData.length"
    >
      <el-button type="warning" plain @click="delMedicalPackage"
        >删除疫苗记录</el-button
      >
    </div>
    <!-- 分页 -->
    <page
      :total="page.total"
      @change="changePage"
      style="margin-top: 22px"
    ></page>
  </div>
</template>

<script>
import page from "@/components/page.vue";
import { editmodel } from "@/api/purchaseApi.js";
export default {
  components: {
    page,
  },
  props: {
    id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      page: {
        page: 1,
        pageSize: 14,
        total: 0,
      },
      tableData: [],
      vaccinesServiceId: "",
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    // 删除疫苗记录
    delMedicalPackage() {
      console.log("删除", this.vaccinesServiceId);
      this.$confirm("确定删除疫苗记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            serviceId: this.vaccinesServiceId,
          };
          this.$http
            .delete("/api/MedicalPackage/Delete", params)
            .then((res) => {
              if (res.code == 0) {
                this.getTableData();
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //跳转疫苗
    // handelNavClick(row) {
    //   this.$router.push({
    //     path: "/yiliao/ymqcSee",
    //     query: { id: row.orderNo },
    //   });
    // },
    //获取数据
    getTableData() {
      let params = {
        petId: this.id,
      };
      editmodel(params).then((res) => {
        if (res.code == 0) {
          console.log(res);
          this.vaccinesServiceId = res.data.vaccinesServiceId;
          this.tableData = res.data.vaccinesInfo;
        }
      });
    },
    //分页方法
    changePage(num) {
      this.page.page = num;
      this.getTableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  min-height: 734px;
  background: #fff;
  margin-top: 12px;
  font-size: 14px;
}
</style>
